import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useState } from "react";
import CheckIcon from "@mui/icons-material/Check";

type CopyButtonProps = {
  onClick: () => void;
  fontSize?: "small" | "medium" | "large";
} & IconButtonProps;

const CopyButton = ({
  onClick,
  fontSize = "small",
  ...props
}: CopyButtonProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    setIsCopied(true);
    onClick();
    setTimeout(() => setIsCopied(false), 2500);
  };

  return (
    <IconButton {...props}>
      {isCopied ? (
        <Tooltip title="Copied" placement="top" arrow>
          <CheckIcon fontSize={fontSize} sx={{ color: "primary.main" }} />
        </Tooltip>
      ) : (
        <ContentCopyIcon
          fontSize={fontSize}
          sx={{ color: "primary.main" }}
          onClick={handleCopy}
        />
      )}
    </IconButton>
  );
};

export default CopyButton;
